export default __webpack_public_path__ + "static/media/resources.9c2d2ecc.svg";